<template>
  <div class="app-container">
    <el-card>
      <!-- <div slot="header" class="clearfix">
        <span>{{ '管理员' }}</span>
      </div> -->
      <div class="filter-container">
        <el-input
          v-model="listQuery.name"
          placeholder="请输入关键字"
          clearable
          style="width: 200px;margin-right: 10px;"
          class="filter-item"
        />
        <el-select
          v-model="listQuery.status"
          placeholder="状态"
          clearable
          class="filter-item"
          style="width: 130px;margin-right: 10px;"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.key"
            :label="item.display_name"
            :value="item.key"
          />
        </el-select>
        <!-- <el-select v-model="listQuery.order" style="width: 140px;margin-right: 10px;" class="filter-item" @change="handleFilter">
          <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key" />
        </el-select> -->
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >
          搜索
        </el-button>
        <el-button
          v-waves
          :disabled="!checkPermission(['larke-admin.admin.create'])"
          class="filter-item"
          type="primary"
          icon="el-icon-refresh-right"
          @click="refreshFilter"
        >
          重置
        </el-button>
        <el-button
          v-waves
          :disabled="!checkPermission(['larke-admin.admin.create'])"
          class="filter-item"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreate"
        >
          添加账号
        </el-button>
        <!-- <el-button v-waves v-permission="['larke-admin.admin.delete']" class="filter-item" type="danger" icon="el-icon-switch-button" @click="handleLogout">
          {{ $t('账号退出') }}
        </el-button> -->
      </div>
      <el-table
        v-loading="listLoading"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :data="list"
        class="border-gray"
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          width="100px"
          label="ID"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="150px"
          label="账号"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100px"
          label="真实姓名"
        >
          <template slot-scope="{row}">
            <span>{{ row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="180px"
          align="left"
          label="添加时间"
        >
          <template slot-scope="scope">
            <span>
              <i class="el-icon-time" />&nbsp;
              {{ scope.row.createTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          class-name="status-col"
          label="状态"
          width="80"
        >
          <template slot-scope="scope">
            <!-- <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              :disabled="!checkPermission(['larke-admin.admin.enable']) || !checkPermission(['larke-admin.admin.disable'])"
              @change="changeStatus($event, scope.row, scope.$index)"
            /> -->
            <el-tag
              v-if="scope.row.status"
              type="success"
            >启用</el-tag>
            <el-tag
              v-if="scope.row.status === 0"
              type="danger"
            >禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="操作"
          width="320"
        >
          <template slot-scope="scope">
            <div>
              <el-button
                v-waves
                type="primary"
                :disabled="!checkPermission(['larke-admin.admin.access'])"
                size="mini"
                icon="el-icon-setting"
                @click="handleAccess(scope.$index, scope.row)"
              >
                设置分组
              </el-button>
              <el-button
                v-waves
                :disabled="!checkPermission(['larke-admin.admin.password'])"
                type="warning"
                size="mini"
                icon="el-icon-key"
                @click="handlePassword(scope.$index, scope.row)"
              >
                改密
              </el-button>
              <el-button
                v-waves
                :loading="scope.row.id == loading.detail"
                :disabled="!checkPermission(['larke-admin.admin.detail'])"
                type="info"
                size="mini"
                icon="el-icon-info"
                @click="handleDetail(scope.$index, scope.row)"
              >
                详情
              </el-button>
            </div>
            <div style="margin-top:5px;">
              <el-button
                v-waves
                :disabled="!checkPermission(['larke-admin.admin.update'])"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-waves
                v-permission="['larke-admin.admin.delete']"
                :loading="scope.row.id == loading.delete"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)"
              >
                删除
              </el-button>

              <!-- <el-button
                v-waves
                v-permission="['larke-admin.admin.delete']"
                :loading="scope.row.id == loading.delete"
                type="primary"
                size="mini"
                icon="el-icon-sunrise-1"
                @click="myPopUpSearch(scope.$index, scope.row)"
              >
                {{ $t('弹窗') }}
              </el-button> -->

              <!-- <el-button
                v-waves
                v-permission="['larke-admin.admin.delete']"
                :loading="scope.row.id == loading.delete"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleBalance(scope.$index, scope.row)"
              >
                设置余额
              </el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </el-card>
    <el-dialog
      title="账号详情"
      :visible.sync="detail.dialogVisible"
    >
      <detail :data="detail.data" />
    </el-dialog>
    <el-dialog
      title="添加账号"
      :visible.sync="create.dialogVisible"
    >
      <create
        :item="create"
        @getNewAdminList="newAdminList"
      />
    </el-dialog>
    <el-dialog
      title="编辑账号"
      :visible.sync="edit.dialogVisible"
    >
      <edit :item="edit" @updata="getList()" />
    </el-dialog>-
    <el-dialog
      title="更改密码"
      :visible.sync="password.dialogVisible"
    >
      <el-form>
        <el-form-item label="新密码">
          <el-input
            v-model.trim="password.data.password"
            type="password"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="changePassword"
          >
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="退出账号"
      :visible.sync="logout.dialogVisible"
    >
      <el-form>
        <el-form-item label="账号的RefreshToken">
          <el-input
            v-model="logout.refreshToken"
            type="textarea"
            rows="6"
            placeholder="请输入账号的RefreshToken"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onLogout"
          >确认退出</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="设置分组"
      :visible.sync="access.dialogVisible"
    >
      <access :item="access" />
    </el-dialog>

    <el-dialog
      title="弹窗"
      :visible.sync="popUpSearch.dialogVisible"
    >
      <PopUpSearch />
    </el-dialog>

    <el-dialog
      title="设置余额"
      :visible.sync="balance.dialogVisible"
    >
      <SetBalance
        :item="balance.item"
        @change="balance.dialogVisible = false, balance.item = null"
      />
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import waves from '@/directive/waves' // waves directive
import { parseTime } from '@/utils'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import Detail from '@/components/Larke/Detail'
import Edit from './components/Edit'
import Create from './components/Create'
import Access from './components/Access'
import PopUpSearch from './components/PopUpSearch.vue'
import SetBalance from './components/SetBalance.vue'
import {
  getList,
  getAdminRule,
  getDetail,
  deleteAdmin,
  enableAdmin,
  disableAdmin,
  updatePassword,
  logoutAdmin
} from '@/api/admin'

export default {
  name: 'Admin',
  components: { Pagination, Detail, Edit, Create, Access, PopUpSearch, SetBalance },
  directives: { waves, permission, parseTime },
  filters: {

  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        name: null,
        status: null,
        page: 1,
        page_size: 10
      },
      statusOptions: [
        { key: '1', display_name: '启用' },
        { key: '0', display_name: '禁用' }
      ],
      // sortOptions: [
      //   { key: 'ASC', label: this.$t('正序') },
      //   { key: 'DESC', label: this.$t('倒叙') }
      // ],
      create: {
        dialogVisible: false
      },
      edit: {
        dialogVisible: false,
        id: ''
      },
      detail: {
        dialogVisible: false,
        data: []
      },
      access: {
        id: '',
        name: '',
        dialogVisible: false
      },
      password: {
        dialogVisible: false,
        data: {
          id: '',
          password: ''
        }
      },
      logout: {
        dialogVisible: false,
        refreshToken: ''
      },
      loading: {
        detail: '',
        delete: ''
      },
      popUpSearch: {
        dialogVisible: false
      },
      balance: {
        dialogVisible: false,
        item: null
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    checkPermission,
    getAdminRuleData() {
      getAdminRule().then(res => {
        console.log(res)
      })
    },
    getList() {
      this.listLoading = true
      getList(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
        this.getAdminRuleData()
      })
    },
    newAdminList() {
      this.getList()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    refreshFilter() {
      this.listQuery = {
        name: null,
        status: null,
        page: 1,
        page_size: 10
      }
      this.getList()
    },
    handleCreate() {
      this.create.dialogVisible = true
    },
    handleEdit(index, row) {
      this.edit.dialogVisible = true
      this.edit.id = row.id
    },
    handleAccess(index, row) {
      this.access.id = row.id
      this.access.name = row.name
      this.access.dialogVisible = true
    },
    handleBalance(index, item) {
      this.balance.item = item
      this.balance.dialogVisible = true
    },
    handleDetail(index, row) {
      this.loading.detail = row.id
      getDetail(row.id).then((res) => {
        this.detail.dialogVisible = true
        const data = res.data

        this.loading.detail = ''

        this.detail.data = [
          {
            name: 'ID',
            content: data.id,
            type: 'text'
          },
          {
            name: '账号',
            content: data.name,
            type: 'text'
          },
          {
            name: '真实姓名',
            content: data.realName,
            type: 'text'
          },
          {
            name: '邮箱',
            content: data.email,
            type: 'text'
          },
          {
            name: '简介',
            content: data.introduce,
            type: 'text'
          },
          {
            name: '分组',
            content: data.groups,
            type: 'arr2str',
            arrkey: 'title'
          },
          {
            name: '头像',
            content: data.avatar,
            type: 'image'
          },
          {
            name: '加入时间',
            content: data.create_time,
            type: 'time'
          },
          {
            name: '最近活动',
            content: data.last_active,
            type: 'time'
          },
          {
            name: '最近活动IP',
            content: data.last_ip,
            type: 'text'
          },
          {
            name: '激活状态',
            content: data.status,
            type: 'boolen'
          }
        ]
      }).catch(() => {
        this.loading.detail = ''
      })
    },
    changeStatus(e, data, index) {
      if (data.status === 1) {
        enableAdmin(data.id).then(() => {
          this.$message({
            message: '管理员启用成功',
            type: 'success',
            duration: 2 * 1000
          })
        })
      } else {
        disableAdmin(data.id).then(() => {
          this.$message({
            message: '管理员禁用成功',
            type: 'success',
            duration: 2 * 1000
          })
        })
      }
    },
    handleDelete(index, row) {
      this.$confirm('确认要删除该管理员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading.delete = row.id

        deleteAdmin(row.id).then(() => {
          this.loading.delete = ''
          this.getList()
          this.$message({
            message: '删除管理员成功',
            type: 'success',
            duration: 5 * 1000,
            onClose() {
              this.list.splice(index, 1)
            }
          })
        }).catch(() => {
          this.loading.delete = ''
        })
      }).catch(() => {

      })
    },
    handlePassword(index, row) {
      this.password.dialogVisible = true
      this.password.data.id = row.id
    },
    changePassword() {
      if (this.password.data.password === '') {
        this.$message({
          message: '密码不能为空',
          type: 'error',
          duration: 5 * 1000
        })
        return false
      }
      // 用md5加密密码
      this.password.data.password = md5(this.password.data.password)
      updatePassword(this.password.data).then(() => {
        this.password.data.password = ''
        this.password.dialogVisible = false
        this.$message({
          message: '管理员密码修改成功',
          type: 'success',
          duration: 5 * 1000
        })
      }).catch(() => {
        this.password.data.password = ''
      })
    },
    handleLogout() {
      this.logout.dialogVisible = true
    },
    onLogout() {
      if (this.logout.refreshToken === '') {
        this.$message({
          message: 'refreshToken 不能为空',
          type: 'error',
          duration: 5 * 1000
        })

        return false
      }
      logoutAdmin(this.logout.refreshToken).then(() => {
        this.$message({
          message: '管理员退出成功',
          type: 'success',
          duration: 5 * 1000,
          onClose() {
            this.logout.refreshToken = ''
            this.logout.dialogVisible = false
          }
        })
      })
    },
    myPopUpSearch(index, row) {
      this.popUpSearch.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.pagination-container {
  padding: 5px 2px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
